// Arabisch (ar), languagesApp: zelfde vorm als languagesApp.nl.ts. De taalnamen zelf staan in
// LOCALE_INFO (altijd in hun eigen taal en schrift).
export const appLanguagesAr = {
    title: 'اللغة',
    settingsBody: 'اللغة التي ترون بها التطبيق والأجهزة اللوحية والرسائل الإلكترونية',
    welcomeTitle: 'أهلًا بكم. ما اللغة التي تتحدثونها في البيت؟',
    welcomeBody: 'اختاروا لغة عائلتكم. يمكنكم تغييرها لاحقًا في أي وقت من الإعدادات.',
    continue: 'متابعة',
    household: 'لغة العائلة',
    householdHint: 'للتطبيق والأجهزة اللوحية والرسائل الإلكترونية. كل فرد وكل جهاز لوحي يتبع هذه اللغة، إلا إذا اخترت غير ذلك.',
    saved: 'تم حفظ اللغة',
    partial: 'لم تُترجم كل النصوص بعد. ما ينقص يظهر باللغة الهولندية.',
    digitsTitle: 'الأرقام',
    digitsLatin: 'أرقام عادية (1 2 3)',
    digitsArabic: 'أرقام عربية (١ ٢ ٣)',
    digitsHint: 'للأوقات والأعداد، على الأجهزة اللوحية وفي التطبيق.',
    overridesTitle: 'لغة خاصة',
    overridesBody: 'هل يفضّل أحدكم لغة أخرى، أو يوجد جهاز لوحي في إحدى الغرف؟ اختر ذلك في العائلة وفي الأجهزة اللوحية.',
    overridesOff: 'اللغة الخاصة لكل شخص أو جهاز مطفأة. يمكنك تشغيلها في الوحدات.',
    toMembers: 'إلى العائلة',
    toDevices: 'إلى الأجهزة اللوحية',
    sameAsFamily: 'مثل العائلة ({language})',
    memberLabel: 'اللغة',
    memberHint: 'للتطبيق والرسائل الإلكترونية الخاصة بـ {name}.',
    deviceLabel: 'لغة هذا الجهاز',
    deviceHint: 'مفيد لجهاز لوحي في إحدى الغرف. وإلا فهو يتبع العائلة.',
    deviceSaved: '{name} يتحدث الآن {language}',
    ownLanguage: 'يتحدث {language}',
    authLabel: 'اللغة',
};
//# sourceMappingURL=languagesApp.ar.js.map